<script setup lang="ts">
interface TrustPoint {
  icon: string;
  title: string;
  description: string;
}

const trustPoints: TrustPoint[] = [
  {
    icon: "lucide:handshake",
    title: "One Accountable Partner",
    description:
      "Connectivity, security and IT under one roof. No more blame game between your internet guy and your security guy.",
  },
  {
    icon: "lucide:headset",
    title: "Australian Service Desk",
    description:
      "No overseas call centers. Fast, local support when you need it, with responsive follow-through.",
  },
  {
    icon: "lucide:check-circle-2",
    title: "Zero-Drama Projects",
    description:
      "We plan migrations to minimize downtime and keep you trading. Parallel systems during switchover.",
  },
  {
    icon: "lucide:award",
    title: "Proven Capability",
    description:
      "Trusted by 500+ businesses across construction, retail, healthcare, and professional services.",
  },
];
</script>

<template>
  <section class="bg-white py-20 lg:py-24">
    <div class="mx-auto max-w-7xl px-8">
      <!-- Section header -->
      <div class="text-center">
        <p class="text-sm font-semibold uppercase tracking-wider text-primary-400">
          Why Metwide
        </p>
        <h2
          class="mt-2 text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl"
        >
          Why long-term clients stay
        </h2>
        <p class="mx-auto mt-4 max-w-2xl text-lg leading-7 text-neutral-600">
          We've built our reputation on reliability, responsiveness, and results.
        </p>
      </div>

      <!-- Trust points grid -->
      <div class="mt-16 grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
        <div
          v-for="point in trustPoints"
          :key="point.title"
          class="group relative flex flex-col rounded-2xl border border-neutral-200 bg-white p-8 text-center shadow-xs transition-all duration-300 hover:-translate-y-1"
        >
          <!-- Icon (Hero style - large, standalone, with hover scale) -->
          <div class="mx-auto mb-6">
            <Icon
              :name="point.icon"
              size="48"
              class="text-mw-accent-500 transition-transform duration-300 group-hover:scale-110"
            />
          </div>

          <!-- Content -->
          <h3 class="text-xl font-extrabold text-dark">
            {{ point.title }}
          </h3>
          <p class="mt-3 flex-1 text-base leading-7 text-neutral-600">
            {{ point.description }}
          </p>

          <!-- Bottom accent line (scales from left on hover) -->
          <div
            class="absolute inset-x-0 bottom-0 h-1 origin-left scale-x-0 rounded-b-2xl bg-primary-400 transition-transform duration-300 group-hover:scale-x-100"
            aria-hidden="true"
          ></div>
        </div>
      </div>
    </div>
  </section>
</template>
